import React, { useEffect, useState } from "react";
import Headline from "../../../atoms/Headline";
import { object } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import AuthorDetails from "../../../molecules/AuthorDetails";
import { getAuthorName, getExcerpt } from "../../../utils/utils";
import { getAuthorObj } from "../../../helper/api";

import "./organism1.m.css";

const Organism1 = ({ story: { story }, publisherAttributes }) => {
  const storyObj = story;
  const authorObj = storyObj.authors[0];
  const authorName = getAuthorName(story);
  const excerpt = getExcerpt(story);
  const role = authorObj && authorObj["contributor-role"] && authorObj["contributor-role"].name;
  const headlineStyle = `${publisherAttributes.lang}-story-headline`;
  const excerptStyle = `${publisherAttributes.lang}-excerpt`;
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  const organism1StyleName = `${publisherAttributes.lang}-base base`;

  const [firstauthorObj, setFirstAuthorObj] = useState({});

  const fetchAuthorObj = async authorId => {
    if (authorId) {
      const data = await getAuthorObj(authorId);
      setFirstAuthorObj(data);
    }
  };
  useEffect(() => {
    fetchAuthorObj(authorObj.id);
  }, []);

  return (
    <div styleName={organism1StyleName} className="base organism1">
      <Link href={storyObj.url}>
        {storyObj.subheadline && (
          <Headline
            text={storyObj.subheadline}
            headlineType={4}
            headerLevel={4}
            className={`sub-headline ${publisherAttributes.lang === "en" ? "en-subheadline" : ""}`}
            styleName={subHeadlineStyle}
          />
        )}
        {storyObj.headline && (
          <Headline
            text={storyObj.headline}
            headlineType={26}
            headerLevel={2}
            headlineDesign="withbackground"
            styleName={headlineStyle}
          />
        )}
      </Link>
      {excerpt ? (
        <Link href={story.url}>
          <Headline
            text={excerpt}
            headerLevel={4}
            className={`story-excerpt ${publisherAttributes.lang === "en" ? "en-story-excerpt" : ""}`}
            styleName={excerptStyle}
          />
        </Link>
      ) : null}
      <AuthorDetails
        story={storyObj}
        authorObj={firstauthorObj}
        authorName={authorName}
        withAvatar={true}
        slug={`author/${authorObj.slug}`}
        contributorType={2}
        role={role}
        authorDetailsType={"opinion-stories-author-details"}
      />
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(Organism1);
